import { NextPage } from "next";
import { getGlobals } from "@models/globals.model";
import { Sanity } from "@models/sanity.model";
import { AccountGlobalSchema, getUserAccountGlobals } from "@models/user-account-globals";
import AccountAuth from "@components/account-auth";

export interface BillingPageProps extends Sanity.PageProps {
  accountGlobals: AccountGlobalSchema;
}

const BillingPage: NextPage<BillingPageProps> = ({ globals, accountGlobals }) => {
  const { states } = globals;

  return (
    <AccountAuth
      globals={globals}
      accountGlobals={accountGlobals}
      pageID="billing"
      seo={{ title: "Account | My Membership" }}
      states={states}
    />
  );
};

export default BillingPage;

export async function getStaticProps() {
  const [globals, accountGlobals] = await Promise.all([
    await getGlobals(),
    await getUserAccountGlobals(),
  ]);
  return {
    props: {
      globals,
      accountGlobals,
    },
  };
}
